"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEAvatar = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _styles = require("@material-ui/core/styles");

var _Avatar = _interopRequireDefault(require("@material-ui/core/Avatar"));

var _Badge = _interopRequireDefault(require("@material-ui/core/Badge"));

var _Add = _interopRequireDefault(require("@material-ui/icons/Add"));

require("./FAEAvatar.scss");

const _excluded = ["size", "variant", "className", "badgeContent", "alt", "getImageSrc", "editAble"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const useStyles = (0, _styles.makeStyles)(theme => ({
  small: {
    width: theme.spacing(7),
    height: theme.spacing(7)
  },
  medium: {
    width: theme.spacing(16),
    height: theme.spacing(16)
  },
  large: {
    width: theme.spacing(20),
    height: theme.spacing(20)
  }
}));

const FAEAvatar = _ref => {
  let {
    size = "medium",
    variant,
    className = "",
    badgeContent = /*#__PURE__*/_react.default.createElement("label", {
      className: "image-upload",
      htmlFor: "input"
    }, /*#__PURE__*/_react.default.createElement(_Add.default, {
      style: {
        border: "2px solid white",
        borderRadius: "50%",
        background: "#f7f7f7",
        cursor: "pointer"
      }
    })),
    alt = "",
    getImageSrc = () => {},
    editAble
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const classes = useStyles();
  const [src, setSrc] = (0, _react.useState)("");
  const imageSize = size === "small" ? classes.small : size === "medium" ? classes.medium : classes.large;

  const imageHandler = event => {
    event.preventDefault();
    const reader = new FileReader();

    reader.onload = () => {
      if (reader.readyState === 2) {
        setSrc(reader.result);
        getImageSrc(reader.result);
      }
    };

    if (event.target.files[0]) {
      reader.readAsDataURL(event.target.files[0]);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, editAble ? /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement("input", {
    type: "file",
    accept: "image/*",
    name: "image-upload",
    id: "input",
    onChange: imageHandler,
    style: {
      display: "none"
    }
  }), /*#__PURE__*/_react.default.createElement(_Badge.default, {
    overlap: "circular",
    anchorOrigin: {
      vertical: "bottom",
      horizontal: "right"
    },
    badgeContent: badgeContent
  }, /*#__PURE__*/_react.default.createElement(_Avatar.default, _extends({
    alt: alt,
    src: src,
    className: imageSize + className,
    variant: variant
  }, rest)))) : /*#__PURE__*/_react.default.createElement(_Avatar.default, _extends({
    alt: alt,
    src: src,
    className: imageSize + className,
    variant: variant
  }, rest)));
};

exports.FAEAvatar = FAEAvatar;